export default {
    required: 'حقل مطلوب',
    minRequired: 'حقل مطلوب، الحد الأدنى للطول %{min}',
    maxRequired: 'حقل مطلوب، الحد الأقصى للطول %{max}',
    email: 'بريد إلكتروني خاطئ',
    passwordMatch: 'يجب ان تتطابق كلمات المرور',
    invalidLoginDetails: 'تفاصيل الدخول خاطئة',
    thisAccountIsBanned: 'هذا الحساب محظور'
}
